import { createStore, featureFlagsStore } from 'freely-shared-stores';

export const useFeatureFlagsStore = createStore(featureFlagsStore, {
  name: 'useFeatureFlagsStore',
  persistType: 'sessionStorage',
});
